import React, { useEffect, useRef } from 'react';
import './Pipeline.css';

const programs = [
  {
    name: 'STX-ADC02',
    target: 'GPC3',
    progress: 62,
    highlight: 'IND / First-in-Human filing targeted for H2 2026',
  },
  {
    name: 'STX-210',
    target: 'Undisclosed',
    progress: 50,
    highlight: 'Target disclosure & in vivo POC data in Q4 2026',
  },
  {
    name: 'ADC Expansion Programs',
    target: 'Multiple',
    progress: 28,
    highlight: 'Multiple solid tumor programs',
  },
];

export default function Pipeline() {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    // animate bars when visible
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const bars = node.querySelectorAll('.progress-bar[data-percent]');
            bars.forEach((b) => {
              const pct = b.getAttribute('data-percent');
              b.style.width = pct + '%';
            });
            io.disconnect();
          }
        });
      },
      { threshold: 0.2 }
    );
    io.observe(node);
    return () => io.disconnect();
  }, []);

  return (
    <section id="pipeline" className="pipeline" ref={ref} aria-label="Pipeline">
      <div className="heading">Pipeline</div>
      <div className="sub">Building a Focused and Scalable ADC Portfolio</div>

      <div className="table-wrap">
      <table className="pipeline-table" role="table" aria-label="Pipeline table">
        <colgroup>
          <col style={{ width: '180px' }} />
          <col style={{ width: '140px' }} />
          <col />
          <col />
          <col />
          <col style={{ width: '260px' }} />
        </colgroup>
        <thead>
          <tr>
            <th>Program</th>
            <th>Target</th>
            <th>Discovery</th>
            <th>Preclinical</th>
            <th>Clinical</th>
            <th>Highlight</th>
          </tr>
        </thead>
        <tbody>
          {programs.map((p) => (
            <tr key={p.name}>
              <td>
                <div className="program-name">{p.name}</div>
              </td>
              <td>{p.target}</td>
              <td colSpan="3" className="progress-cell">
                <div className="progress-bar-wrap" aria-hidden="true">
                  <div className="progress-bar" data-percent={p.progress} style={{ width: 0 }} />
                </div>
              </td>
              <td className="highlight">{p.highlight}</td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </section>
  );
}

